import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentConfirmInformationV2Data,
  type EnrollmentConfirmInformationV2SubmitOutput,
} from '../../../../../models'
import {
  EmploymentStatus,
  EnrollmentInvestmentExperienceCategory,
  EnrollmentInvestmentObjectiveCategory,
  EnrollmentTaxFilingStatusType,
  Occupation,
  PersonalNetWorthRange,
} from '../../../../../models/enrollment/enrollment'

export const getEnrollmentConfirmInformationV2DataMock: EnrollmentConfirmInformationV2Data = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/confirm-information/traditional-ira',

  enrollmentData: {
    applicationId: '1234567890',

    userInfo: {
      employmentStatus: EmploymentStatus.Employed,
      income: 1000000,
      netWorthRange: PersonalNetWorthRange.Over_5M,
      occupation: Occupation.TechnologyIt,
      taxFilingStatus: EnrollmentTaxFilingStatusType.HeadOfHousehold,
      investment: {
        isBrokerDealer: false,
        isDirectorPolicyMakerOfCompany: true,
        directorPolicyMakerOfCompanyName: 'TSLA',
        isPoliticallyExposedPerson: true,
        affiliatedPoliticalOrganizations: ['Tesla', 'Apple', 'SpaceX'],
        hasPoliticallyExposedImmediateFamilyMembers: true,
        politicallyExposedImmediateFamilyMembers: ['Elon Musk'],
        objective: EnrollmentInvestmentObjectiveCategory.GenerateIncome,
        experience: EnrollmentInvestmentExperienceCategory.None,
      },
    },
  },
}

export const submitEnrollmentConfirmInformationV2DataMock: EnrollmentConfirmInformationV2SubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  missingField: 'proceedConfirmInfo',
  path: '/enrollment/investments/disclosures/traditional-ira/',
}

export const mockGetEnrollmentConfirmInformationV2Data = graphql.mutation(
  'getEnrollmentConfirmInformationV2Data',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentConfirmInformationV2DataMock } })
  },
)

export const mockSubmitEnrollmentConfirmInformationV2Data = graphql.mutation(
  'submitEnrollmentConfirmInformationV2Data',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentConfirmInformationV2DataMock } })
  },
)

export const mockEnrollmentConfirmInformationV2 = [
  mockGetEnrollmentConfirmInformationV2Data,
  mockSubmitEnrollmentConfirmInformationV2Data,
]
